export default "__VITE_ASSET__CMUbyFUT__"